module.exports = "<button mat-raised-button color=\"warn\">Log Out From All Device</button>\n"